(function () {
  var DUTCH_DAY_NAMES = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var DEFAULT_CUTOFF_HOUR = 17;
  var SUNDAY_CUTOFF_HOUR = 14;

  function getAmsterdamCalendar() {
    var d = new Date();
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
      hourCycle: 'h23',
      weekday: 'short',
    });
    var parts = fmt.formatToParts(d);
    var o = {};
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type !== 'literal') o[p.type] = p.value;
    }
    var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var y = parseInt(o.year, 10);
    var m = parseInt(o.month, 10);
    var day = parseInt(o.day, 10);
    var hour = parseInt(o.hour, 10);
    var dow = wdMap[o.weekday];
    if (dow === undefined) {
      dow = civilWeekday(y, m, day);
    }
    if (hour !== hour) {
      hour = 0;
    }
    return { y: y, m: m, d: day, hour: hour, dow: dow };
  }

  function civilWeekday(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  }

  function addCalendarDays(y, m, d, delta) {
    var t = Date.UTC(y, m - 1, d + delta);
    var x = new Date(t);
    return {
      y: x.getUTCFullYear(),
      m: x.getUTCMonth() + 1,
      d: x.getUTCDate(),
      dow: x.getUTCDay(),
    };
  }

  function isWorkingDay(dow) {
    return dow >= 1 && dow <= 5;
  }

  function addWorkingDaysFrom(cal, workingDaysToAdd) {
    var target = { y: cal.y, m: cal.m, d: cal.d, dow: cal.dow };
    var remaining = workingDaysToAdd;
    while (remaining > 0) {
      target = addCalendarDays(target.y, target.m, target.d, 1);
      if (isWorkingDay(target.dow)) remaining -= 1;
    }
    return target;
  }

  function getNextDeliveryDow(weekdayCutoffHour, sundayCutoffHour) {
    var cutoff = weekdayCutoffHour || DEFAULT_CUTOFF_HOUR;
    var sunCut =
      sundayCutoffHour !== undefined && sundayCutoffHour !== null && !isNaN(sundayCutoffHour)
        ? sundayCutoffHour
        : SUNDAY_CUTOFF_HOUR;
    var cal = getAmsterdamCalendar();
    var h = cal.hour;
    var dow = cal.dow;
    var target;

    if (dow >= 1 && dow <= 5) {
      if (h < cutoff) {
        target = addCalendarDays(cal.y, cal.m, cal.d, 1);
      } else {
        target = addCalendarDays(cal.y, cal.m, cal.d, 2);
      }
      if (target.dow === 0) {
        target = addCalendarDays(target.y, target.m, target.d, 1);
      }
    } else if (dow === 6) {
      target = addWorkingDaysFrom(cal, h < cutoff ? 1 : 2);
    } else {
      target = addWorkingDaysFrom(cal, h < sunCut ? 1 : 2);
    }

    return target.dow;
  }

  function getDeliveryDayLabel(weekdayCutoffHour, sundayCutoffHour) {
    var dow = getNextDeliveryDow(
      weekdayCutoffHour || DEFAULT_CUTOFF_HOUR,
      sundayCutoffHour
    );
    return DUTCH_DAY_NAMES[dow];
  }

  function updateContainer(container) {
    if (!container) return;

    var cutoff = Number(container.getAttribute('data-delivery-cutoff')) || DEFAULT_CUTOFF_HOUR;
    var sunAttr = container.getAttribute('data-sunday-cutoff');
    var sundayCut = sunAttr !== null && sunAttr !== '' ? Number(sunAttr) : SUNDAY_CUTOFF_HOUR;
    if (isNaN(sundayCut)) sundayCut = SUNDAY_CUTOFF_HOUR;

    var dayLabel = getDeliveryDayLabel(cutoff, sundayCut);
    var placeholders = container.querySelectorAll('.delivery-date');

    if (placeholders.length > 0) {
      placeholders.forEach(function (node) {
        node.textContent = dayLabel;
      });
      return;
    }

    var html = container.innerHTML;
    var withPlaceholder = html.replace(
      /\(\s*day\s*\)/gi,
      '<span class="delivery-date">' + dayLabel + '</span>'
    );
    if (withPlaceholder !== html) {
      container.innerHTML = withPlaceholder;
      return;
    }

    var dayPattern = /\b(morgen|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|zondag)\b/i;
    if (dayPattern.test(html)) {
      container.innerHTML = html.replace(
        dayPattern,
        '<span class="delivery-date">' + dayLabel + '</span>'
    );
    }
  }

  function updateAll(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('.js-dynamic-delivery');
    containers.forEach(updateContainer);
  }

  function boot() {
    updateAll(document);
    setInterval(function () {
      updateAll(document);
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateAll(event.target);
  });

  window.MousecakeDeliveryDate = {
    updateAll: updateAll,
    getDeliveryDayLabel: getDeliveryDayLabel,
  };
})();
